import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { createAvatarSynthesizer, createWebRTCConnection } from "./Utility";
import { avatarAppConfig } from "./config";

import { MdMic, MdMicOff } from "react-icons/md";
import { useTheme } from "../BrandColors/Context/ThemeContext";

const Avatar = ({ userPrompt }) => {
  const [loading, setLoading] = useState(true); // Add this state
  const navigate = useNavigate();
  const theme = useTheme() || "#3b82f6";

  const handleBack = () => {
    navigate('/avatar-selection');
  }
  const userQueriesHistory = [];

  const [avatarSynthesizer, setAvatarSynthesizer] = useState(null);
  const [mySpeechText, setMySpeechText] = useState("");
  const [microphoneEnabled, setMicrophoneEnabled] = useState(true);
  var [speechRecognizer, setSpeechRecognizer] = useState(null);
  const location = useLocation();
  const {
    selectedImage = ["Lisa", "casual-sitting"],
    voiceOption = "en-US-AvaMultilingualNeural",
    script,
    prompt
  } =
    location.state || {};
  const [isListening, setIsListening] = useState(false);
  let formData = {
    avatar: selectedImage[0],
    style: selectedImage[1],
    voice: voiceOption
  };
  useEffect(() => {
    if (!loading) {
      setTimeout(() => {
        speakSelectedText(script)
      }, 5000)
    }
  }, [script, prompt, loading])
  const myAvatarVideoEleRef = useRef();
  const myAvatarAudioEleRef = useRef();
  const myAvatarCanvasRef = useRef(null);
  const disconnectRef = useRef();
  const iceUrl = avatarAppConfig.iceUrl;
  const iceUsername = avatarAppConfig.iceUsername;
  const iceCredential = avatarAppConfig.iceCredential;
  var cogSvcRegion = avatarAppConfig.cogSvcRegion;
  var cogSvcSubKey = avatarAppConfig.cogSvcSubKey;
  var sarvamAPIKey = avatarAppConfig.sarvamAPIKey;
  useEffect(() => {
    window.addEventListener("beforeunload", handleWindowClose);
    return () => {
      window.removeEventListener("beforeunload", handleWindowClose);
    };
  }, []);

  useEffect(() => {
    startSession();
  }, []);
  const startSession = () => {
    setLoading(true);
    const peerConnection = createWebRTCConnection(
      iceUrl,
      iceUsername,
      iceCredential
    );
    peerConnection.ontrack = handleOnTrack;
    peerConnection.addTransceiver("video", { direction: "sendrecv" });
    peerConnection.addTransceiver("audio", { direction: "sendrecv" });

    const avatarSynth = createAvatarSynthesizer(formData); // Pass formData
    setAvatarSynthesizer(avatarSynth);

    peerConnection.oniceconnectionstatechange = e => {
      console.log("WebRTC status: " + peerConnection.iceConnectionState);

      if (peerConnection.iceConnectionState === "connected") {
        console.log("Connected to Azure Avatar service");
        setLoading(false);
      }

      if (
        peerConnection.iceConnectionState === "disconnected" ||
        peerConnection.iceConnectionState === "failed"
      ) {
        console.log("Azure Avatar service Disconnected");
      }
    };

    avatarSynth
      .startAvatarAsync(peerConnection)
      .then(() => {
        console.log("Avatar started.");

      })
      .catch(error => {
        console.log("Avatar failed to start. Error: " + error);
        setLoading(false); // Ensure loading stops even on failure
      });

    const speechRecognitionConfig = SpeechSDK.SpeechConfig.fromEndpoint(
      new URL(
        `wss://${cogSvcRegion}.stt.speech.microsoft.com/speech/universal/v2`
      ),
      cogSvcSubKey
    );
    speechRecognitionConfig.setProperty(
      SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode,
      "Continuous"
    );
    const sttLocales = ["en-US", "de-DE", "es-ES"];
    const autoDetectSourceLanguageConfig = SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages(
      sttLocales
    );
    const speechRecog = SpeechSDK.SpeechRecognizer.FromConfig(
      speechRecognitionConfig,
      autoDetectSourceLanguageConfig,
      SpeechSDK.AudioConfig.fromDefaultMicrophoneInput()
    );
    setSpeechRecognizer(speechRecog);
  };

  const handleOnTrack = (event) => {
    if (event.track.kind === 'video') {
      const mediaPlayer = myAvatarVideoEleRef.current;
      mediaPlayer.id = event.track.kind;
      mediaPlayer.srcObject = event.streams[0];
      mediaPlayer.autoplay = true;
      mediaPlayer.playsInline = true;
      mediaPlayer.addEventListener('play', () => {
        window.requestAnimationFrame(() => { });
      });
    } else {
      const audioPlayer = myAvatarAudioEleRef.current;
      audioPlayer.srcObject = event.streams[0];
      audioPlayer.autoplay = true;
      audioPlayer.playsInline = true;
      audioPlayer.muted = true;
    }
  };
  const handleUserHistory = async (userQuery) => {
    userQueriesHistory.push(userQuery);
    const slot_prompt = userPrompt || prompt;
    const bodyPayload = {
      model: "sarvam-105b", // Or use sarvam-30b based on your preference
      messages: [
        { role: "system", content: slot_prompt },
        { role: "user", content: userQuery },
      ],
    };

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${sarvamAPIKey}`);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(bodyPayload),
      redirect: "follow",
    };

    try {
      const response = await fetch(
        "https://api.sarvam.ai/v1/chat/completions",
        requestOptions
      );
      const data = await response.json();
      let answer = data?.choices[0]?.message?.content;
      console.log("Answer", answer)
      // setMySpeechText(answer)
      speakSelectedText(answer)

      console.log("SPEAK");
    } catch (error) {
      console.error("Error fetching or parsing response:", error);
    }
  };
  const stopSession = () => {
    if (avatarSynthesizer) {
      console.log("stop");
      avatarSynthesizer
        .stopSpeakingAsync()
        .then(() => {
          avatarSynthesizer.close();
        })
        .catch(error => {
          console.log("Error stopping session", error);
        });
    }
  };

  const speakSelectedText = (query) => {
    if (!query) {
      return
    }
    //Start speaking the text
    const audioPlayer = myAvatarAudioEleRef.current || {};
    audioPlayer['muted'] = false;
    avatarSynthesizer.speakTextAsync(query).then(
      (result) => {
        if (result.reason === SpeechSDK.ResultReason.SynthesizingAudioCompleted) {
          console.log("Speech and avatar synthesized to video stream.")
        } else {
          console.log("Unable to speak. Result ID: " + result.resultId)
          if (result.reason === SpeechSDK.ResultReason.Canceled) {
            let cancellationDetails = SpeechSDK.CancellationDetails.fromResult(result)
            console.log(cancellationDetails.reason)
            if (cancellationDetails.reason === SpeechSDK.CancellationReason.Error) {
              console.log(cancellationDetails.errorDetails)
            }
          }
        }
      }).catch((error) => {
        console.log(error)
        avatarSynthesizer.close()
      });
  }

  const applyChromaKeyEffect = () => {
    const video = myAvatarVideoEleRef.current;
    const canvas = myAvatarCanvasRef.current;
    const ctx = canvas.getContext("2d");

    const chromaKey = () => {
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      const frame = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = frame.data;

      const greenThreshold = {
        rMin: 0,
        rMax: 100,
        gMin: 100,
        gMax: 255,
        bMin: 0,
        bMax: 100
      };
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];

        if (
          r >= greenThreshold.rMin &&
          r <= greenThreshold.rMax &&
          g >= greenThreshold.gMin &&
          g <= greenThreshold.gMax &&
          b >= greenThreshold.bMin &&
          b <= greenThreshold.bMax
        ) {
          data[i + 3] = 0; // Set alpha to 0 for transparency
        }
      }

      ctx.putImageData(frame, 0, 0);
      requestAnimationFrame(chromaKey);
    };

    video.addEventListener("play", () => {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      chromaKey();
    });
  };

  const handleWindowClose = event => {
    console.log("User is trying to refresh or close the window");
    event.preventDefault();
    if (disconnectRef.current) {
      console.log("DIS");
      disconnectRef.current.click();
    }
  };


  const microphone = async e => {
    e.preventDefault();
    console.log("mic button clicked");
    avatarSynthesizer
      .stopSpeakingAsync()
      .then(() => {
        setIsListening(true);
        console.log(
          "[" + new Date().toISOString() + "] Stop speaking request sent."
        );
      })
      .catch();
    speechRecognizer.recognized = async (s, e) => {
      if (e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
        let userQuery = e.result.text.trim();
        console.log("userQuery", userQuery);
        handleUserHistory(userQuery)
        // speakSelectedText()
        if (userQuery === "") {
          return;
        }

        const continuousConversation = false;
        if (!continuousConversation) {
          setMicrophoneEnabled(false);
          speechRecognizer.stopContinuousRecognitionAsync(
            () => {
              setMicrophoneEnabled(true);
              setIsListening(false);
            },
            err => {
              console.log("Failed to stop continuous recognition:", err);
              setMicrophoneEnabled(true);
            }
          );
        }
      }
    };

    speechRecognizer.startContinuousRecognitionAsync(
      () => {
        setMicrophoneEnabled(true);
      },
      err => {
        console.log("Failed to start continuous recognition:", err);
        setMicrophoneEnabled(true);
      }
    );
  };
  const stopMicrophone = async () => {
    try {
      console.log("Stopping microphone...");
      setIsListening(false);
      setMicrophoneEnabled(true);
      await avatarSynthesizer.stopSpeakingAsync();
      console.log("Avatar stopped speaking.");

      speechRecognizer.stopContinuousRecognitionAsync(
        () => {
          console.log("Speech recognition stopped.");
          setMicrophoneEnabled(true);
        },
        err => {
          console.error("Failed to stop continuous recognition:", err);
        }
      );
    } catch (error) {
      console.error("Error while stopping the microphone:", error);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center w-full min-h-screen relative overflow-hidden bg-blue-50/50 backdrop-blur-sm animate-fade-in-up">

      <div className="relative w-full max-w-4xl mx-auto rounded-3xl overflow-hidden glass-panel shadow-2xl border border-blue-200/50">

        {loading && (
          <div className="absolute inset-0 z-50 flex items-center justify-center bg-blue-50/80 backdrop-blur-md">
            <div className="w-16 h-16 border-4 border-blue-200 border-t-[var(--theme-color)] rounded-full animate-spin" style={{ '--theme-color': theme }}></div>
          </div>
        )}

        <div className="relative w-full min-h-[50vh] md:h-[600px] flex items-center justify-center bg-white">
          <video
            className="myAvatarVideoElement"
            ref={myAvatarVideoEleRef}
            onLoadedData={applyChromaKeyEffect}
            style={{ display: "none" }}
          />
          <audio ref={myAvatarAudioEleRef} />
          <canvas ref={myAvatarCanvasRef} className="w-full h-full object-contain" />
        </div>

        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2">
          <button 
            className="w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 transform hover:scale-110 active:scale-95 text-white"
            style={{ backgroundColor: isListening ? '#f43f5e' : theme }}
            onClick={!isListening ? microphone : stopMicrophone}
          >
            {!isListening ? <MdMic size={28} /> : <MdMicOff size={28} />}
          </button>
        </div>
      </div>
      
      <button
        ref={disconnectRef}
        className="hidden"
        onClick={stopSession}
      >
        Disconnect
      </button>
    </div>
  );
};
export default Avatar;
